// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 461 ? "webfontloader" : chunkId) + "." + {"461":"2b277969","960":"95cbf264"}[chunkId] + ".js";
};